import { handleActions } from 'redux-actions';
import * as actions from './actions';

const defaultState = {
  isSigning: false,
  signError: null
};

const authByGoogleReducer = handleActions(
  {
    [actions.googleSignInRequest]: (state, action) => ({ ...state, isSigning: true }),
    [actions.googleSignInSuccess]: (state, action) => ({ ...state, isSigning: false, signError: null }),
    [actions.googleSignInFailed]: (state, action) => ({ ...state, isSigning: false, signError: action.payload }),

    [actions.resetGoogleErrors]: (state, action) => ({ ...state, signError: null }),
  },
  defaultState
);

export default authByGoogleReducer;